import React from "react";
import { Button, Card, Col, Placeholder, Row } from "react-bootstrap";
import { LeagueWithSportsAndSeries } from "../../../types/model";
import { FaFlagCheckered, FaHandPointRight } from "react-icons/fa";
import { IoGlobeOutline } from "react-icons/io5";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { RootState } from "../../../store/store";
import { useNavigate } from "react-router-dom";
import InviteFriendsModal from "./InviteFreindsModal";
import { setShowLoginModal } from "../../../store/slices/userSlice";

interface LeagueTitleCardProps {
	league: LeagueWithSportsAndSeries;
	handleEditLeague?: () => void;
	handleJoinLeague?: () => void;
	handleLeaveLeague?: () => void;
	showJoinButton?: boolean;
	joinLoading?: boolean;
}

const LeagueTitleCard: React.FC<LeagueTitleCardProps> = ({
	league,
	handleEditLeague,
	handleJoinLeague,
	handleLeaveLeague,
	showJoinButton = true,
	joinLoading = false,
}) => {
	const user = useAppSelector((state: RootState) => state.user.user);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { isLoggedIn } = useAppSelector((state: RootState) => state.user);
	const { seasons } = useAppSelector((state: RootState) => state.fantasy);

	const isActiveSeason = seasons.some(
		(season) => season._id === league?.season && season.isActive,
	);

	const [inviteFriendsModal, setInviteFriendsModal] = React.useState(false);
	const handleInviteFriends = () => {
		setInviteFriendsModal(true);
	};

	return (
		<Card
			className="text-center py-4 ms-sm-4 ms-2"
			style={{
				backgroundColor: "transparent",
				border: "none",
				maxWidth: "23rem",
			}}
		>
			<Card.Body className="text-start">
				<div
					style={{
						fontSize: "1.2rem",
						fontWeight: "bold",
						color: "#ADB5BD",
					}}
					className="mb-0 text-start"
				>
					{league.featured ? (
						<IoGlobeOutline className="me-1 mb-1" />
					) : (
						<FaFlagCheckered className="me-1 mb-1" />
					)}
					{league.name}
				</div>
				<div
					style={{
						fontSize: "3.5rem",
						fontWeight: "bold",
						color: "#ADB5BD",
						lineHeight: "1",
					}}
					className="mb-0 text-start"
				>
					{league.series.name}
				</div>
				<div
					style={{
						fontSize: "3.5rem",
						fontWeight: "bold",
						lineHeight: "1",
					}}
					className="text-white mt-0 text-start"
				>
					{league.sport.name}
				</div>
				<div className="mt-2 text-start fs-6 text-white fw-bold">
					{league.description}
				</div>
				{isLoggedIn ? (
					<div className="mt-4">
						<div className="d-grid gap-2">
							{showJoinButton ? (
								<>
									{joinLoading ? (
										<Placeholder
											as="div"
											animation="glow"
											className="w-100 mb-1"
										>
											<Placeholder
												xs={11}
												className="rounded-3"
												bg="light"
												style={{ height: "2.5rem" }}
											/>
										</Placeholder>
									) : (
										<Button
											variant="primary"
											size="sm"
											className="fw-bold text-light py-2 fs-6"
											onClick={handleJoinLeague}
										>
											JOIN LEAGUE
										</Button>
									)}
								</>
							) : (
								<Button
									variant="success"
									size="sm"
									className="fw-bold text-light py-2 fs-6"
									disabled={!isActiveSeason}
									onClick={() =>
										navigate(
											`/editteam?sport=${league.sport?._id}&series=${league.series?._id}&leagueId=${league._id}`,
										)
									}
								>
									EDIT MY TEAM
								</Button>
							)}
						</div>
						{user && league?.admins.find((admin) => admin == user?._id) && (
							<Button
								variant="outline-light"
								className="w-100 mt-2 fw-bold py-2 fs-6"
								onClick={handleEditLeague}
							>
								EDIT LEAGUE
							</Button>
						)}
						<div className="mt-2">
							<Row className="g-2">
								<Col xs={12} md={6}>
									<Button
										variant="outline-light"
										size="sm"
										className="fw-bold w-100"
										onClick={handleInviteFriends}
									>
										INVITE FRIENDS
									</Button>
								</Col>
								<Col xs={12} md={6}>
									<Button
										variant="outline-light"
										size="sm"
										className="fw-bold  w-100"
										disabled
									>
										TEAM HISTORY
									</Button>
								</Col>
							</Row>
						</div>
						{!showJoinButton && !league.featured && (
							<div className="mt-2">
								<Button
									variant="outline-light"
									size="sm"
									className="fw-bold w-100"
									onClick={handleLeaveLeague}
								>
									LEAVE LEAGUE
								</Button>
							</div>
						)}
					</div>
				) : (
					<Button
						variant="primary"
						size="lg"
						className="fw-bold text-light px-4 mt-4"
						onClick={() => dispatch(setShowLoginModal(true))}
					>
						JOIN THE LEAGUE
					</Button>
				)}
			</Card.Body>
			<InviteFriendsModal
				inviteFriendsModal={inviteFriendsModal}
				setInviteFriendsModal={setInviteFriendsModal}
				league={league}
			/>
		</Card>
	);
};

export default LeagueTitleCard;
